import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import ReactGA from 'react-ga';

import AppBar from './components/AppBar';
import Footer from './components/Footer';
import StepOneContainer from './containers/StepOneContainer/StepOneContainer';
import StepTwoContainer from './containers/StepTwoContainer/StepTwoContainer';
import StepThreeContainer from './containers/StepThreeContainer/StepThreeContainer';
import StepFourContainer from './containers/StepFourContainer/StepFourContainer';

ReactGA.initialize('UA-93235839-2');

class App extends Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    if (window.innerWidth !== this.state.width) {
      this.setState({
        width: window.innerWidth,
      });
    }
  }

  render() {
    const stepOne = () => <StepOneContainer {...this.props} />;
    const stepTwo = () => <StepTwoContainer {...this.props} />;
    const stepThree = () => <StepThreeContainer {...this.props} />;
    const stepFour = () => <StepFourContainer {...this.props} />;
    const redirect = () => <Redirect to={`${process.env.PUBLIC_URL}/`} />;

    return (
      <div className="App">
        <Router
          // basename={'/base'}
        >
          <React.Fragment>
          <AppBar />
          <Switch>
            <Route path={`${process.env.PUBLIC_URL}/`} exact component={stepOne} />
            <Route path={`${process.env.PUBLIC_URL}/step2`} exact component={stepTwo} />
            <Route path={`${process.env.PUBLIC_URL}/step3`} exact component={stepThree} />
            <Route path={`${process.env.PUBLIC_URL}/step4`} exact component={stepFour} />
            <Route exact component={redirect} />
          </Switch>
          <Footer />
          </React.Fragment>
        </Router>
      </div>
    );
  }
};

export default App;
